import {
    BlurEvent, Button, ChangeEvent, ClickEvent, DataSource, DataSourceExecutionEvent, DataSourceMode, DropdownSelectionEvent,
    LookupModelSelectionEvent, Switch, Table, TableRow, TableRowDisplayEvent, Textbox, AddType,
    LookupModelSearchEvent
} from "@mcleod/components";
import { Alignment, Api, CompanySettings, Currency, CurrencyProps, CurrencySettings, CurrencyUtil, ModelRow, PermissionsUtil,
    StringUtil } from "@mcleod/core";
import { CommonDialogs,CommonTooltips } from "@mcleod/common";
import { AssetUtil, getDispatchControlBoolean } from "@mcleod/general";
import { ModelEdiorderProfile } from "@mcleod/datafusion";
import { MovementCarrierPay } from "@mcleod/powerbroker";
import { AutogenLayoutBillingRates } from "./autogen/AutogenLayoutBillingRates";
import {ChargeTaxUtil, OtherChargesUtil, RateUtil, TaxUtil} from "@mcleod/dispatch";
import { DistanceAlertUtil } from "@mcleod/dispatch/src/DistanceAlertUtil";import { getExciseTaxControlBoolean } from "./models/ModelExciseTaxControl";

export class BillingRates extends AutogenLayoutBillingRates {
    private _allocationEnabled: boolean;
    private _calculatingCharges: boolean = false;
    private chargePanelExpanded: boolean = true;
    private ratingDetailsPanelExpanded: boolean = false;
    private taxPanelExpanded: boolean = false;
    private estimateFuelSurcharge: boolean = getDispatchControlBoolean("est_fuel_surcharge")
    private autoRate: boolean = getDispatchControlBoolean("auto_rate");
    private otherChargesUtil: OtherChargesUtil = new OtherChargesUtil();
    private taxUtil: TaxUtil = new TaxUtil();
    private chargeTaxUtil: ChargeTaxUtil = new ChargeTaxUtil();
    private _invokedFromEdi: boolean = false;
    private _currencyFromProfile: string = null;
    private _currencyTypeFromQuote: string;
    private distanceAlertUtil = new DistanceAlertUtil();
    doAfterRating: () => void;
    checkPickupAndDeliveryEntered = () => true;
    private recalculatingTotals: boolean = false;

    override onLoad(): void {
        this.textboxCollectionMethod.items = RateUtil.getCollectionMethodDropdownItems();
        this.textboxCtrlParty.textCombined.manualAddLayout = null;
        this.buttonEstimateFuelSurcharge.visible = !this.estimateFuelSurcharge;
        this.otherChargesUtil.initialize(this);
        this.taxUtil.initialize(this);
        this.chargeTaxUtil.initialize(this);
        this.initializeRatingDetails();
        this.textboxCurrencyType.visible = CurrencySettings.getSingleton().multiCurrencyEnabled();
        if (!CurrencySettings.getSingleton().multiCurrencyEnabled()) {
            this.textboxCurrencyType.defaultDataValue = CurrencySettings.getFunctionalCurrency();
        } else {
            this.panelTaxes.visible = true;
        }
        if (!CompanySettings.getSingleton().isAsset()) {
            this.tableOtherCharges.removeColumn(this.tableOtherCharges.columns.find(col => "columnHeaderDriver" === col.headingCell.id));
        }
    }

    async sourceOrdersAfterExecution(event: DataSourceExecutionEvent) {
        if (CurrencySettings.getSingleton().multiCurrencyEnabled()) {
            this.panelExciseTaxTotal.visible = true;
            this.panelTotalWithTaxes.visible = true;
            if (this.mainDataSource.mode !== DataSourceMode.ADD) {
                const transactionalCurrency = await this.getTransactionalCurrency();
                const orderCurrencyCode = this.mainDataSource.activeRow?.get("linehaul_chg_c", transactionalCurrency) as string;
                this.mainDataSource.activeRow?.setLookupModelData("linehaul_chg_c", { currency_type_id: orderCurrencyCode });
                this.mainDataSource.displayDataInBoundComponent(this.textboxCurrencyType);
                this.otherChargesUtil.currencyType = orderCurrencyCode;
                this.taxUtil.currencyType = orderCurrencyCode;
            }
        }
        await RateUtil.enableDisableUnitsAndRates(this, this.activeRow?.get("rate_type"), false, false, false);
        const rateId = this.mainDataSource.activeRow?.get("rate_id", null);
        const origDestRateId = this.sourceOrders.activeRow?.get("orig_dest_rate_id", null);
        if (rateId != null && origDestRateId != null) {
            RateUtil.setAutoRateContext(this, this.mainDataSource.activeRow?.get("rate_id"), this.sourceOrders.activeRow?.get("orig_dest_rate_id"));
        }
        const segAllocCode = this.sourceOrders.activeRow?.get("seg_alloc_code");
        this.textboxSegAllocCode.visible = segAllocCode != null;
    }

    async sourceBillingAfterExecution(event: DataSourceExecutionEvent) {
        this.textboxRateUnits.enabled = this.mainDataSource.activeRow?.get("rate_type") === "O";
    }

    setMaxTargetPayData() {
        const maxPayData = this.mainDataSource.activeRow?.get("max_target_pay_data");
        if (maxPayData != null && this.carrierPayLayout?.visible == true) {
            this.setupMaxTargetPanel(true);
            this.carrierPayLayout.setDataFromResponse(maxPayData);
            this.mainDataSource.activeRow.set("max_target_pay_data", undefined);
        }
    }

    getOtherChargeDatasource(): DataSource {
        return this.sourceOtherChargeBill;
    }

    getTaxDatasource(): DataSource {
        return this.sourceExcisetaxChargeBill;
    }

    get carrierPayLayout(): MovementCarrierPay {
        return this.layoutMovementRates as MovementCarrierPay
    }

    set calculatingCharges(value: boolean) {
        this._calculatingCharges = value;
    }

    get calculatingCharges(): boolean {
        return this._calculatingCharges;
    }

    public getTaxTable() {
        return this.tableTax;
    }

    get currencyTypeFromQuote(): string {
        return this._currencyTypeFromQuote;
    }

    set currencyTypeFromQuote(currencyTypeFromQuote: string) {
        this._currencyTypeFromQuote = currencyTypeFromQuote;
    }

    textboxSegAllocCodeBeforeLookupModelSearch(event) {
        event.filter.alloc_type = 'M';
        event.filter.is_active = 'Y';
    }

    buttonExpandChargesOnClick(event: ClickEvent) {
        const transitionProps = { speed: 100, paddingTop: 0 };
        if (this.chargePanelExpanded) this.panelOtherChargeTable.collapse(transitionProps).then(() => {
            this.buttonExpandCharges.imageRotation = 90
        }); else this.panelOtherChargeTable.expand(transitionProps).then(() => {
            this.buttonExpandCharges.imageRotation = 0
        });
        this.chargePanelExpanded = !this.chargePanelExpanded;
    }

    buttonExpandTaxesOnClick(event: ClickEvent) {
        const transitionProps = { speed: 100, paddingTop: 0 };
        if (this.taxPanelExpanded) this.panelTaxTable.collapse(transitionProps).then(() => {
            this.buttonExpandTaxes.imageRotation = 90
        }); else this.panelTaxTable.expand(transitionProps).then(() => {
            this.buttonExpandTaxes.imageRotation = 0
        });
        this.taxPanelExpanded = !this.taxPanelExpanded;
    }

    buttonExpandDetailsOnClick(event: ClickEvent) {
        const transitionProps = { speed: 100, paddingTop: 0 };
        if (this.ratingDetailsPanelExpanded) this.panelRatingDetailsTable.collapse(transitionProps).then(() => {
            this.buttonExpandDetails.imageRotation = 90
        }); else this.panelRatingDetailsTable.expand(transitionProps).then(() => {
            this.buttonExpandDetails.imageRotation = 0
        });
        this.ratingDetailsPanelExpanded = !this.ratingDetailsPanelExpanded;
    }

    async sourceBillingAfterModeChange(event) {
        if ((event.newMode == DataSourceMode.ADD || event.newMode == DataSourceMode.UPDATE) && event.newMode != event.oldMode) {
            this.setupMaxTargetPanel(true);
            this.sourceOtherChargeBill.mode = DataSourceMode.ADD;
            if (this.activeRow) {
                if (CurrencySettings.getSingleton().multiCurrencyEnabled() && getExciseTaxControlBoolean("is_active", false)) {
                    this.setTaxesVisible(true);
                } else {
                    this.setTaxesVisible(false);
                    this.tableOtherCharges.removeColumn("columnHeaderTaxable");
                    this.tableOtherCharges.removeColumn("columnHeaderBackhaulTax");
                }
            }
        }
        RateUtil.setRateListeners(this);
        if (event.newMode === DataSourceMode.ADD || event.newMode === DataSourceMode.UPDATE) {
            CurrencyUtil.configureCurrencySelector(this.textboxCurrencyType);
        }
    }

    private setupMaxTargetPanel(visible: boolean) {
        this.carrierPayLayout.visible = !AssetUtil.isAssetMoveType(this.sourceOrders)
            && (this.activeRow == null || !this.activeRow?.getBoolean("multi_movement", false))
            && visible;
        this.panelRateTotals.borderBottomRightRadius = visible ? 0 : 4;
        this.panelRateTotals.borderBottomLeftRadius = visible ? 0 : 4;
        if (this.carrierPayLayout.mainDataSource.activeRow == null) this.carrierPayLayout.configureForOrderEntry(this.sourceOrders, true);
    }

    async otherChargesOnBlur(event: BlurEvent) {
        await this.otherChargesUtil.otherChargeOnBlur(event);
    }

    async taxesOnBlur(event: BlurEvent) {
        await this.taxUtil.taxOnBlur(event)
    }

    buttonEstimateFuelSurchargeOnClick(event: ClickEvent) {
        this.ratingButtonClicked(event, false, true);
    }

    buttonRateOnClick(event: ClickEvent) {
        this.ratingButtonClicked(event, true);
    }

    ratingButtonClicked(event: ClickEvent, autoRate: boolean, estimateFsc: boolean = this.estimateFuelSurcharge) {
        const button = event.target as Button;
        button.busy = true;
        this.calculateRates(autoRate, estimateFsc).finally(() => {
            button.busy = false
            if (CurrencySettings.getSingleton().multiCurrencyEnabled() && this.otherChargesUtil.currencyType) {
                this.convertPricingCurrencies(this.otherChargesUtil.currencyType);
            }
        });
    }

    async textboxChargeIdOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (event.hasSelection() === true)
            await this.otherChargesUtil.textboxChargeIdOnLookupModelSelection(event, this.sourceBilling.activeRow.get("id"));
    }

    async textboxExciseTaxIdOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (event.hasSelection() === true) {
            await this.taxUtil.textboxExciseTaxIdOnLookupModelSelection(event, this.sourceBilling.activeRow.get("id"));
        }
    }

    async tableOtherChargesOnContentsChanged(event) {
        if (this.mainDataSource.mode === DataSourceMode.SEARCH || this.recalculatingTotals) return;
        this.recalculatingTotals = true;
        try {
            await this.otherChargesUtil.tableOtherChargeBillOnContentsChanged();
            await this.calculateRates(false, false);
        } finally {
            this.recalculatingTotals = false;
        }
    }

    async tableTaxOnContentsChanged(event) {
        if (this.mainDataSource.mode === DataSourceMode.SEARCH) return;
        this.taxUtil.tableTaxOnContentsChanged();
    }

    tableTaxOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow() as TableRow;
        const modelRow: ModelRow = tableRow.data as ModelRow;
        const isEstimated = modelRow.getBoolean("is_estimated", false);

        if (isEstimated) {
            // Prevent row from entering edit mode
            tableRow.allowEdit = false;

            // Override the delete button to show a message instead of deleting
            tableRow.deleteRow = async () => {
                await CommonDialogs.showMessage(
                    "Generated excise tax records cannot be deleted. These records are automatically calculated and managed by the system."
                );
            };
        }
    }

    /**
     * Updates excise taxes for the current billing record.
     * Delegates to TaxUtil for the actual implementation.
     *
     * @param taxesList - Optional list of tax rows to use instead of fetching from server
     * @param showDialog - Whether to show error dialogs to the user
     */
    public async updateExciseTaxes(taxesList?: ModelRow[], showDialog: boolean = false): Promise<void> {
        await this.taxUtil.updateExciseTaxes(taxesList, showDialog, "B");
    }

    async calculateRates(autorate: boolean = this.autoRate, affectRateId: boolean = true): Promise<any> {
        const billingWithAll: ModelRow = this.mainDataSource.activeRow;
        this.mainDataSource.fillLinkedValues(billingWithAll, null);
        const orderRow: ModelRow = this.sourceOrders.getDataboundValues(null, true, null, null);
        const stopRows: ModelRow[] = this.mainDataSource.childDataSources.find((source) => source.id == "sourceStop")?.data
        this.mainDataSource.setComponentsBusy(true);
        this.calculatingCharges = true;
        try {
            if (CurrencySettings.getSingleton().multiCurrencyEnabled()) {
                this.mainDataSource.activeRow?.set("linehaul_chg", this.activeRow?.get("linehaul_chg"));
            }
            const body = {
                "autorate": autorate,
                "billing_row": billingWithAll,
                "other_charges": this.sourceOtherChargeBill.data?.map(row => row.data) || [],
                "include_billing_charges": true  // Ensure server includes billing-specific charges
            };
            const response = await Api.search("lme/ar/calculate-billing-charges", body);

            let totalChargeChanged = false;
            const data = response.data[0];
            if (!data) return;
            const billingApiData = data["billing_row"] || [];

            this.setBillDistanceWarnings(data);

            if (stopRows != null) {
                const stopApiData = data["stop_data"] || [];
                stopApiData.forEach((stop, index) => {
                    if (stopRows[index]) {
                        stopRows[index].data["rate_dist_from_previous"] = stop["rate_dist_from_previous"];
                    }
                });
            }

            // Auto Rate
            if (autorate) {
                for (let i = this.tableOtherCharges.rows.length - 1; i >= 0; i--) {
                    const row = this.tableOtherCharges.rows[i];
                    if (row?.data?.data["rate_id"] != null) {
                        row.deleteRow()
                    }
                }
            }

            if (autorate) {
                const appendingId: string[] = [];
                this.tableOtherCharges.rows.forEach(row => {
                    if (row.data?._appending == false) appendingId.push(row.data?._data["id"])
                });
                this.sourceOtherChargeBill.data = [];
                const otherCharges = data["other_charges"] || [];
                otherCharges.forEach(element => {
                    const isAppending = appendingId.length == 0 || !appendingId.includes(element["id"]);
                    const modelRow = new ModelRow(this.sourceOtherChargeBill.url, isAppending);
                    modelRow.setValues(element);
                    this.sourceOtherChargeBill.data.push(modelRow);
                });
                this.tableOtherCharges.displayData(null, this.sourceOtherChargeBill.data, 0);
            } else if (CurrencySettings.getSingleton().multiCurrencyEnabled()) {
                this.tableOtherCharges.displayData(null, this.sourceOtherChargeBill.data, 0);
            }

            this.textboxRateType.setSelectedItemFromValue(billingApiData["rate_type"]);
            this.mainDataSource.activeRow.set("rate_type", billingApiData["rate_type"]);
            this.mainDataSource.activeRow.set("distance", billingApiData["distance"]);
            this.mainDataSource.activeRow.set("rating_method", billingApiData["rating_method"]);
            this.mainDataSource.activeRow.set("rate", billingApiData["rate"]);
            this.mainDataSource.activeRow.set("rating_units", billingApiData["rating_units"]);

            if (CurrencySettings.getSingleton().multiCurrencyEnabled()) {
                const tempCurrency: Currency = new Currency(billingApiData["linehaul_chg"] as CurrencyProps);
                tempCurrency.setConversionDate(this.activeRow.getCurrency("linehaul_chg")?.getConversionDate());
                if (billingApiData["linehaul_chg_c"] != this.otherChargesUtil.currencyType)
                    tempCurrency.setCurrencyCode(this.otherChargesUtil.currencyType);
                this.activeRow.set("linehaul_chg", tempCurrency);
            } else if (billingApiData["linehaul_chg"] != null &&
                (this.activeRow.getCurrency("linehaul_chg")?.amount != billingApiData["linehaul_chg"]?.amount
                    || this.activeRow.getCurrency("linehaul_chg")?.currency_code != billingApiData["linehaul_chg"]?.currency_code)) {
                this.mainDataSource.activeRow.set("linehaul_chg", billingApiData["linehaul_chg"]);
                this.mainDataSource.activeRow.set("linehaul_chg_n", billingApiData["linehaul_chg_n"]);
            }
            if (billingApiData["total_charges"] != null) {
                if (billingApiData["total_charges"].amount != this.mainDataSource.activeRow.get("total_charge")?.amount || 0) {
                    this.mainDataSource.activeRow.set("total_charges", billingApiData["total_charges"]);
                    this.mainDataSource.activeRow.set("total_charges_n", billingApiData["total_charges_n"]);
                    totalChargeChanged = true;
                }
            }            // Recalculate other charges and ensure total_charges is consistent
            const otherChargeAmount = await this.otherChargesUtil.getOtherChargeBillTotal(false);
            this.mainDataSource.activeRow.set("other_charge", otherChargeAmount);

            // Only recalculate total_charges if it wasn't set from server or if other charges changed
            const recalculatedTotal = await this.otherChargesUtil.getOtherChargeBillTotal(true);
            const currentTotal = this.mainDataSource.activeRow.get("total_charges");

            // Enhanced validation: Check if server total matches client calculation
            // This catches data source synchronization issues
            if (!currentTotal || Math.abs(currentTotal.amount - recalculatedTotal.amount) > 0.01) {
                console.warn(`Total charges mismatch detected - Server: ${currentTotal?.amount || 'null'}, Client: ${recalculatedTotal.amount}. Using client calculation.`);
                this.mainDataSource.activeRow.set("total_charges", recalculatedTotal);
                totalChargeChanged = true;
            }

            // Additional validation: Ensure billing and order data are synchronized
            this.validateDataSourceConsistency();
            if (CurrencySettings.getSingleton().multiCurrencyEnabled()) {
                const exciseTaxes = data["excise_taxes"] || [];
                await this.updateExciseTaxes(exciseTaxes)
                const orderCurrency = this.mainDataSource.activeRow?.get("freight_charge_c", await this.getTransactionalCurrency()) as string;
                await this.convertPricingCurrencies(orderCurrency);
            }
            this.mainDataSource.activeRow.set("excisetax_total", this.taxUtil.getTaxChargeBillTotal(false));
            this.mainDataSource.activeRow.set("totalcharge_and_excisetax", this.taxUtil.getTaxChargeBillTotal(true));

            if (affectRateId) {
                const origDestRateId = data["orig_dest_rate_id"] || orderRow.get("orig_dest_rate_id", null);
                RateUtil.setAutoRateContext(this, billingApiData["rate_id"], origDestRateId);
            }
            if (totalChargeChanged && this.doAfterRating != null) this.doAfterRating();
        } finally {
            this.calculatingCharges = false;
            this.mainDataSource.setComponentsBusy(false);
        }
    }

    /**
     * Sets the warning state for the bill distance textbox based on the response from the Model.
     * If there is an error message in the response, it sets the textbox properties to display a warning.
     * Otherwise, it resets the properties to default values.
     *
     * @param response - The response from the Model: lme/dispatch/calculate-order-charges.
     */
    private setBillDistanceWarnings(response: any) {
        const errorMessage = response?.["message"];
        if (errorMessage) {
            this.textboxBillDistance.color = "warning";
            this.textboxBillDistance.borderColor = "warning";
            this.textboxBillDistance.borderWidth = 1;
            this.textboxBillDistance.tooltip = errorMessage;
            this.textboxBillDistance.allowTooltip = true;
        } else {
            this.textboxBillDistance.color = "default";
            this.textboxBillDistance.borderColor = undefined;
            this.textboxBillDistance.borderWidth = undefined;
            this.textboxBillDistance.tooltip = undefined;
            this.textboxBillDistance.allowTooltip = false;
        }
    }

    /** This is an event handler for the onChange event of checkboxLockMiles.  */
    checkboxLockMilesOnChange(event) {
        this.textboxBillDistance.enabled = event.newValue === false;
    }

    sourceRatingDetailsAfterExecution(event: DataSourceExecutionEvent) {
        this.initializeRatingDetails();
    }

    /** This is an event handler for the afterExecution event of sourceDistanceAlert. */
    sourceDistanceAlertAfterExecution(event: DataSourceExecutionEvent) {
        this.distanceAlertUtil.checkForDistanceAlertsTextbox(this.sourceDistanceAlert, this.textboxBillDistance);
    }

    initializeRatingDetails() {
        this.switchByFreightItem.checked = true;
        this.tableRevSummary.visible = false;
        this.panelRatingDetailsTable.collapse({ speed: 100, paddingTop: 0 }).then(() => {
            this.buttonExpandDetails.imageRotation = 90;
        });
    }

    switchByFreightItemOnClick(event: ClickEvent) {
        const switchByFreightItem = event.target as Switch;
        this.tableRevPerFgi.visible = switchByFreightItem.checked;
        this.tableRevSummary.visible = !switchByFreightItem.checked;
    }

    tableRevPerFgiOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow: TableRow = event.getTableRow() as TableRow;
        this.addBuySellTooltips(tableRow, "textboxFgiRevenueAmount");
    }

    tableRevSummaryOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow: TableRow = event.getTableRow() as TableRow;
        this.addBuySellTooltips(tableRow, "textboxRevenueAmount");
    }

    addBuySellTooltips(tableRow: TableRow, componentId: string) {
        const modelRow: ModelRow = tableRow.data as ModelRow;
        const buyRateModelRow = new ModelRow(modelRow._modelPath, false, modelRow.data);
        buyRateModelRow.set("charge_as_calc_description", modelRow.get("buy_rate_description"));
        buyRateModelRow.set("tariff_id", modelRow.get("tariff_id"));
        buyRateModelRow.set("tli_uid", modelRow.get("tli_uid"));
        if (buyRateModelRow.get("tariff_id", null) != null) {
            const component = tableRow.findComponentById(componentId);
            if (component != null) {
                CommonTooltips.setTooltipContentLayout(component, buyRateModelRow,
                    "lme/dispatch/RevenueDetailQuickInfo");
                component.tooltipDynamicOptions = { position: Alignment.TOP };
            }
        }
    }

    textboxChargeCalcMethodOnDropdownSelection(event: DropdownSelectionEvent) {
        if (event.selection?.value === "D") {
            const tableRow = TableRow.getContainingTableRow(event.target as Textbox);
            const distance = this.sourceOrders.activeRow.get("bill_distance", null);
            this.setChargeDistanceUnits(tableRow, distance);
        }
    }


    textboxMethodOnDropdownSelection(event: DropdownSelectionEvent) {
        this.textboxRateUnits.enabled = this.mainDataSource.activeRow.get("rate_type") === "O";
    }

    setChargeDistanceUnits(tableRow: TableRow, distance: string) {
        const units = tableRow.findComponentById("textboxChargeUnits") as Textbox;
        units.text = distance;
        const rate = tableRow.data.get("rate");
        if (rate != null) {
            const amount = tableRow.findComponentById("textboxChargeAmount") as Textbox;
            amount.text = (parseFloat(rate) * parseFloat(distance)).toFixed(2);
        }
    }

    async textboxCurrencyTypeOnLookupModelSelection(event: LookupModelSelectionEvent) {
        const selectedRow = event.selection;
        if (selectedRow) {
            const currencyType = selectedRow.get("currency_type_id", await this.getTransactionalCurrency()) as string;
            this.convertPricingCurrencies(currencyType);
        }
    }

    convertPricingCurrencies(currencyType: string) {
        this.otherChargesUtil.currencyType = currencyType;
        this.taxUtil.currencyType = currencyType;
        const freightCharge: Currency = this.mainDataSource.activeRow?.getCurrency("linehaul_chg");
        freightCharge?.setCurrencyCode(currencyType);
        freightCharge?.setConversionDate(freightCharge.getConversionDate());
        const otherCharge: Currency = this.mainDataSource.activeRow?.getCurrency("other_charge");
        otherCharge?.setCurrencyCode(currencyType);
        const totalCharge: Currency = this.mainDataSource.activeRow?.getCurrency("total_charges");
        totalCharge?.setCurrencyCode(currencyType);
        const totalTaxes: Currency = this.mainDataSource.activeRow?.getCurrency("excisetax_total");
        totalTaxes?.setCurrencyCode(currencyType);
        const totalWithTaxes: Currency = this.mainDataSource.activeRow?.getCurrency("totalcharge_and_excisetax");
        totalWithTaxes?.setCurrencyCode(currencyType);
        this.mainDataSource.activeRow?.setValues({
            "linehaul_chg": freightCharge, "other_charge": otherCharge, "total_charges": totalCharge,
            "excisetax_total": totalTaxes, "totalcharge_and_excisetax": totalWithTaxes
        });
        this.updateCurrencySelector(currencyType);
        this.tableOtherCharges.rows.forEach((tableRow) => {
            const modelRow: ModelRow = tableRow.data;
            const amount: Currency = modelRow.getCurrency("amount");
            if (amount) {
                amount.setCurrencyCode(currencyType);
                modelRow.set("amount", amount);
                tableRow.displayComponentValues();
            }
        });
        this.tableTax.rows.forEach((tableRow) => {
            const modelRow: ModelRow = tableRow.data;
            const amount: Currency = modelRow.getCurrency("amount");
            if (amount) {
                amount.setCurrencyCode(currencyType);
                modelRow.set("amount", amount);
                tableRow.displayComponentValues();
            }
        });
        const quickAddData: ModelRow = this.tableOtherCharges.quickAddData;
        if (quickAddData) {
            const amount: Currency = quickAddData.getCurrency("amount");
            if (amount) {
                amount.setCurrencyCode(currencyType);
                quickAddData.set("amount", amount);
                this.tableOtherCharges.quickAddRow.displayComponentValues();
            }
        }
        const taxQuickAddData: ModelRow = this.tableTax.quickAddData;
        if (taxQuickAddData) {
            const amount: Currency = taxQuickAddData.getCurrency("amount");
            if (amount) {
                amount.setCurrencyCode(currencyType);
                taxQuickAddData.set("amount", amount);
                this.tableTax.quickAddRow.displayComponentValues();
            }
        }
    }

    async getTransactionalCurrency(): Promise<string> {
        let transactionCurrency = CurrencySettings.getTransactionalCurrency();
        const partner = this.sourceOrders.activeRow?.getString("partner_id");
        const version = this.sourceOrders.activeRow?.getString("partner_version");
        if (this.getInvokedFromEdi() && this.getCurrencyFromProfile()) {
            transactionCurrency = this.getCurrencyFromProfile();
        } else if (partner && version) {
            const profile = await new ModelEdiorderProfile().searchSingle({
                partner_id: partner,
                version: version
            });
            if (profile.data.currency_type_id) {
                transactionCurrency = profile.data.currency_type_id;
            }
        }
        return transactionCurrency;
    }

    public set invokedFromEdi(value: boolean) {
        this._invokedFromEdi = value;
    }

    public getInvokedFromEdi(): boolean {
        return this._invokedFromEdi;
    }

    public set currencyFromProfile(value: string) {
        this._currencyFromProfile = value;
    }

    public getCurrencyFromProfile(): string {
        return this._currencyFromProfile;
    }

    public beforeTextboxStopLookupModelSearch(event) {
        event.filter.order_id = this.sourceOrders.activeRow.get("id");
        event.filter.stop_type = "in PU,SO";
    }

    textboxStopNumberOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (event.hasSelection() === true)
            this.otherChargesUtil.textboxStopNumberOnLookupModelSelection(event);
    }

    textboxStopNumberOnChange(event: ChangeEvent) {
        this.otherChargesUtil.textboxStopNumberOnChange(event);
    }

    private updateCurrencySelector(currencyCode: string) {
        this.mainDataSource.activeRow?.set("linehaul_chg_c", currencyCode);
        this.mainDataSource.activeRow?.setLookupModelData("linehaul_chg_c", { currency_type_id: currencyCode });
        this.mainDataSource.displayDataInBoundComponent(this.textboxCurrencyType);
    }

    additionalChargesOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow: TableRow = event.getTableRow() as TableRow;
        const modelRow: ModelRow = tableRow.data as ModelRow;
        const switchIncludeInFreight = tableRow.findComponentById("switchIncludeInFreight") as Switch;
        if (!StringUtil.isEmptyString(modelRow.get("customer_id"))) {
            switchIncludeInFreight.enabled = false;
            return;
        }
        const isIncludeInFreight = this.mainDataSource?.activeRow?.get("customer.allow_inc_in_frt", "N") === "Y";

        // Configure switch in the current row
        if (switchIncludeInFreight) {
            switchIncludeInFreight.enabled = isIncludeInFreight;
        }

        // Configure switch in the quick add row if it exists
        if (this.tableOtherCharges?.quickAddRow) {
            const quickAddSwitch = this.tableOtherCharges.quickAddRow
                .findComponentById("switchIncludeInFreight") as Switch;

            if (quickAddSwitch) {
                quickAddSwitch.enabled = isIncludeInFreight;
            }
        }
    }

    tableOtherChargesOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow() as TableRow;

        if (this.mainDataSource.mode === DataSourceMode.SEARCH) {
            return;
        }

        this.chargeTaxUtil.handleTableRowDisplay(tableRow);
    }

    async createTaxOnClick() {
        if (this.mainDataSource.mode === DataSourceMode.SEARCH || !this.buttonCreateTax.enabled) return;
        this.buttonCreateTax.busy = true;
        try {
            await this.updateExciseTaxes(null, true);
        } finally {
            this.buttonCreateTax.busy = false;
        }
    }

    async taxMethodAfterDropdownSelection(event: DropdownSelectionEvent) {
        await this.taxUtil.taxOnDropdownSelection(event);
    }

    /**
     * Handler for when switchTaxable changes
     */
    private onSwitchTaxableChange(event: ChangeEvent) {
        this.chargeTaxUtil.onSwitchTaxableChange(event);
    }

    /**
     * Handler for when switchBackhaulTax changes
     */
    private onSwitchBackhaulTaxChange(event: ChangeEvent) {
        this.chargeTaxUtil.onSwitchBackhaulTaxChange(event);
    }

    /**
     * Validates consistency between billing and order data sources
     * Logs warnings when discrepancies are detected that could cause calculation issues
     */
    private validateDataSourceConsistency() {
        const billingRow = this.mainDataSource.activeRow;
        const orderRow = this.sourceOrders.activeRow;

        if (!billingRow || !orderRow) return;

        // Check if order_id matches
        const billingOrderId = billingRow.get("order_id");
        const orderIdFromSource = orderRow.get("id");

        if (billingOrderId !== orderIdFromSource) {
            console.warn(`Data source inconsistency: Billing order_id (${billingOrderId}) != Order id (${orderIdFromSource})`);
        }

        // Check for billing-specific charges that might not be in order
        const billingChargeCount = this.sourceOtherChargeBill.data?.length || 0;
        const billingOnlyCharges = this.sourceOtherChargeBill.data?.filter(row => !row.get("order_charge_id")) || [];

        if (billingOnlyCharges.length > 0) {
            console.info(`Found ${billingOnlyCharges.length} billing-specific charges (not in original order)`);
        }

        // Log environment info for debugging deployment differences
        console.debug(`Environment validation - Total billing charges: ${billingChargeCount}, Billing-only charges: ${billingOnlyCharges.length}`);
    }

    async switchTaxableOrderOnChange(event: ChangeEvent) {
        if (this.activeRow == null || this.mainDataSource.mode === DataSourceMode.SEARCH) return;
        const isChecked = event?.newValue === true;
        const taxRows = this.tableTax.rows;
        if (!isChecked && taxRows.length > 0) {
            const message = "This change will result in a non-taxable invoice and will remove all excise taxes (generated or manual) currently defined for this invoice.\n\nProceed with tax status change for this invoice?";
            const confirm = event.userInitiatedChange ? await CommonDialogs.showYesNo(message) : true;
            if (confirm) {
                for (let i = taxRows.length - 1; i >= 0; i--) {
                    const row = taxRows[i];
                    this.tableTax.deleteRow(row);
                }

                // Recalculate totals and refresh bound controls
                this.taxUtil.tableTaxOnContentsChanged();
                this.mainDataSource.displayDataInBoundComponent(this.textboxExcisetaxTotal);
                this.mainDataSource.displayDataInBoundComponent(this.textboxTotalWithTax);
                this.setExciseTaxableOptions();
            } else {
                this.switchTaxableOrder.checked = true;
                this.setExciseTaxableOptions();
            }
        } else {
            // Turning ON simply enables tax editing options
            this.setExciseTaxableOptions();
        }
    }

    async switchExciseDisableUpdateOnChange(event: ChangeEvent) {
        if (this.activeRow == null || this.mainDataSource.mode === DataSourceMode.SEARCH) return;

        const isChecked = event?.newValue === true;
        const taxRows = this.tableTax.rows.filter(row => row.data.getBoolean("is_estimated", false));

        if (isChecked && taxRows.length > 0) {
            const message = "This change will result in disabling the auto update and will remove all generated excise taxes (manual taxes will remain) currently defined for this bill.\n\nProceed with disable of tax auto update?";
            const confirm = event.userInitiatedChange ? await CommonDialogs.showYesNo(message) : true;
            if (confirm) {
                // Remove estimated (generated) tax rows
                for (let i = taxRows.length - 1; i >= 0; i--) {
                    const row = taxRows[i];
                    if (row.data.getBoolean("is_estimated", false)) {
                        this.tableTax.deleteRow(row);
                    }
                }

                // Recalculate and update totals
                this.taxUtil.tableTaxOnContentsChanged();
                this.mainDataSource.displayDataInBoundComponent(this.textboxExcisetaxTotal);
                this.mainDataSource.displayDataInBoundComponent(this.textboxTotalWithTax);
                this.setExciseTaxableOptions();
            } else {
                // Revert checkbox
                this.switchExciseDisableUpdate.checked = false;
            }
        } else {
            // Update button state when switch is toggled off or there are no tax rows
            this.setExciseTaxableOptions();
        }
    }

    private setTaxesVisible(visible: boolean) {
        this.panelExciseTaxTotal.visible = visible;
        this.panelTotalWithTaxes.visible = visible;
        this.panelTaxes.visible = visible;
        if (!visible) {
            this.tableOtherCharges.removeColumn("columnHeaderTaxable");
        }
        this.setExciseTaxableOptions();
    }

    private setExciseTaxableOptions() {
        const isExciseTaxable: boolean = this.activeRow.getBoolean("excise_taxable", false);
        const isExciseDisableUpdate: boolean = this.activeRow.getBoolean("excise_disable_update", false);
        this.tableTax.allowEdit = isExciseTaxable;
        this.tableTax.addType = isExciseTaxable ? AddType.QUICK : AddType.NOT_ALLOWED;
        this.tableTax.allowDelete = isExciseTaxable;
        this.tableTax.displayToolsCell = isExciseTaxable;
        this.sourceExcisetaxChargeBill.displayDataInBoundComponents();
        this.buttonCreateTax.enabled = isExciseTaxable && !isExciseDisableUpdate;
    }

    textboxStateIdBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.country_id = "in CAN,CAD"; // show only Canadian provinces
    }
}
